export const useSuggestionsStore = defineStore("suggestions", () => {
  const suggestions = reactive<ISuggestion[]>([]);

  return {
    suggestions,
  };
});
